import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Switch,
    FormControlLabel,
    Divider,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

type NotificationSettings = {
    orders: boolean;
    bookings: boolean;
    chat: boolean;
    broadcast: boolean;
    promotions: boolean;
    payments: boolean;
};

export default function ViewOptInNotification({
    open,
    onClose,
    setOpen,
}: ModalProps) {
    const [notifications, setNotifications] = useState<NotificationSettings>({
        orders: true,
        bookings: false,
        chat: true,
        broadcast: false,
        promotions: true,
        payments: true,
    });

    const handleToggle = (key: keyof NotificationSettings) => {
        setNotifications((prev) => ({
            ...prev,
            [key]: !prev[key],
        }));
    };

    return (
        <Modal
            className="modal addNotification_modal"
            open={open}
            onClose={onClose}
        >
            <div className="modal-dialog">
                <div className="modal-body">
                    <div className="modal_title">
                        <h2>Opt-In Notifications</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    <form className="form notification_form">
                        {/* Orders */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={notifications.orders}
                                    onChange={() => handleToggle("orders")}
                                />
                            }
                            label="Order Updates (Placed, Shipped, Delivered)"
                        />

                        <Divider />

                        {/* Bookings */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={notifications.bookings}
                                    onChange={() => handleToggle("bookings")}
                                />
                            }
                            label="Bookings & Appointments"
                        />

                        <Divider />

                        {/* Chat */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={notifications.chat}
                                    onChange={() => handleToggle("chat")}
                                />
                            }
                            label="Chat & Support Messages"
                        />

                        <Divider />

                        {/* Broadcast */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={notifications.broadcast}
                                    onChange={() => handleToggle("broadcast")}
                                />
                            }
                            label="Broadcast Notifications (Admin Announcements)"
                        />

                        <Divider />

                        {/* Promotions */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={notifications.promotions}
                                    onChange={() => handleToggle("promotions")}
                                />
                            }
                            label="Promotions & Offers"
                        />

                        <Divider />

                        {/* Payments */}
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={notifications.payments}
                                    onChange={() => handleToggle("payments")}
                                />
                            }
                            label="Payment & Refund Alerts"
                        />

                      
                    </form>
                </div>
            </div>
        </Modal>
    );
}
